import { render, staticRenderFns } from "./prodTimeSector.vue?vue&type=template&id=4d58cbdc"
import script from "./prodTimeSector.vue?vue&type=script&lang=js"
export * from "./prodTimeSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports